<template>
  <page-view :title="false">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form-model layout="inline">
          <a-row :gutter="48">
            <a-col :md="8" :sm="24">
              <a-form-model-item label="日期"
                ><a-date-picker
                  v-model="queryParam.time"
                  placeholder="日期"
                  style="width: 100%;"
              /></a-form-model-item>
            </a-col>

            <a-col :md="8" :sm="24">
              <a-form-item label="类型">
                <a-select
                  v-model="queryParam.type"
                  placeholder="请选择"
                  allowClear
                >
                  <a-select-option value="">全部</a-select-option>
                  <a-select-option value="advice">建议</a-select-option>
                  <a-select-option value="complaint">投诉</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <template v-if="advanced">
              <a-col :md="8" :sm="24">
                <a-form-item label="状态">
                  <a-select
                    v-model="queryParam.sta"
                    placeholder="请选择"
                    allowClear
                  >
                    <a-select-option value="">全部</a-select-option>
                    <a-select-option value="R">未处理</a-select-option>
                    <a-select-option value="I">已处理</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </template>
            <a-col :md="(!advanced && 8) || 24" :sm="24">
              <span
                class="table-page-search-submitButtons"
                :style="
                  (advanced && { float: 'right', overflow: 'hidden' }) || {}
                "
              >
                <a-button type="primary" @click="$refs.table.refresh(true)"
                  >查询</a-button
                >
                <a-button style="margin-left: 8px" @click="reset"
                  >重置</a-button
                >
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? "收起" : "展开" }}
                  <a-icon :type="advanced ? 'up' : 'down'" />
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form-model>
      </div>

      <!-- 数据表格 -->
      <s-table
        ref="table"
        size="default"
        rowKey="id"
        :scroll="{ x: 1400 }"
        :columns="columns"
        :data="loadData"
        showPagination="auto"
      >
        <span slot="sta" slot-scope="text, record">
          <template>
            {{ text }}
            <a-tag
              class="render-tag"
              :color="record.sta == 'R' ? 'grey' : '#87d068'"
              >{{ record.sta == "R" ? "未处理" : "已回复" }}</a-tag
            >
          </template>
        </span>
        <span slot="rentSta" slot-scope="text, record">
          <template>
            {{ text }}
            <a-tag
              class="render-tag"
              color="#87d068"
              v-if="record.rentSta == '2'"
              >已出租</a-tag
            >
          </template>
        </span>
        <span slot="typeRender" slot-scope="text">
          <template>
            {{ text == "advice" ? "建议" : "投诉" }}
          </template>
        </span>
        <span slot="action" slot-scope="text, record">
          <template>
            <a
              class="a-action"
              v-hasAnyPermission="`advicecomplaint:see`"
              @click="see(record)"
              >查看</a
            >
          </template>
        </span>
      </s-table>
    </a-card>

    <feedback-info
      ref="info"
      @success="$refs.table.refresh(true)"
    ></feedback-info>
  </page-view>
</template>
<script>
import { PageView } from "@/layouts";
import { STable } from "@/components";
import moment from "moment";
import FeedbackInfo from "./FeedbackInfo.vue";
export default {
  components: {
    PageView,
    STable,
    FeedbackInfo
  },
  name: "FeedbackList",
  data() {
    return {
      userInfo: {},
      advanced: false,
      queryParam: {
        sta: "R",
        type: ""
      },
      // 表头
      columns: [
        {
          title: "编号",
          dataIndex: "feedbackNo",
          scopedSlots: { customRender: "sta" },
          fixed: "left",
          width: 200
        },
        {
          title: "姓名",
          dataIndex: "createUser",
          fixed: "left",
          width: 140
        },
        {
          title: "类型",
          dataIndex: "type",
          scopedSlots: { customRender: "typeRender" },
          fixed: "left",
          width: 80
        },
        {
          title: "内容描述",
          dataIndex: "content"
        },
        {
          title: "创建时间",
          dataIndex: "createDatetime",
          width: 220
        },
        {
          title: "修改人",
          dataIndex: "modifyUser",
          width: 120
        },
        {
          title: "修改时间",
          dataIndex: "modifyDatetime",
          width: 220
        },
        {
          title: "操作",
          dataIndex: "action",
          align: "left",
          fixed: "right",
          width: 100,
          scopedSlots: { customRender: "action" }
        }
      ],
      //加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        let param = Object.assign(parameter, this.queryParam);
        if (this.queryParam.time) {
          let date = moment(this.queryParam.time).format(
            "YYYY-MM-DD"
          );
          param.startDate = date + " 00:00:00";
          param.endDate = date + " 23:59:59";
        }
        return this.$http.systemBksApi
          .pageSystemFeedbackRecord(param)
          .then(res => {
            return res.resultObject;
          });
      }
    };
  },
  created() {
    this.userInfo = this.$store.getters.userInfo;
  },
  methods: {
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    reset() {
      this.queryParam = {};
      this.queryParam.sta = "R";
      this.queryParam.type = "";
    },
    see(item) {
      this.$refs.info.showModal(item);
    }
  }
};
</script>

<style lang="less" scoped>
.actions {
  button {
    margin-right: 10px;
  }
}
</style>
